import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["prefixCls", "selectPrefixCls", "className", "size", "locale", "selectComponentClass", "responsive", "showSizeChanger"];
import DoubleLeftOutlined from "@ant-design/icons/DoubleLeftOutlined";
import DoubleRightOutlined from "@ant-design/icons/DoubleRightOutlined";
import LeftOutlined from "@ant-design/icons/LeftOutlined";
import RightOutlined from "@ant-design/icons/RightOutlined";
import classNames from "classnames";
import RcPagination from "rc-pagination";
// @ts-ignore
import enUS from "rc-pagination/lib/locale/en_US";
import * as React from "react";
import { ConfigContext } from "../ConfigProvider";
import useBreakpoint from "../Grid/hooks/useBreakpoint";
import LocaleReceiver from "../LocaleProvider/LocaleReceiver";
import { MiddleSelect, MiniSelect } from "./Select";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Pagination = function Pagination(_ref) {
  var customizePrefixCls = _ref.prefixCls,
    customizeSelectPrefixCls = _ref.selectPrefixCls,
    className = _ref.className,
    size = _ref.size,
    customLocale = _ref.locale,
    selectComponentClass = _ref.selectComponentClass,
    responsive = _ref.responsive,
    showSizeChanger = _ref.showSizeChanger,
    restProps = _objectWithoutProperties(_ref, _excluded);
  var _useBreakpoint = useBreakpoint(responsive),
    xs = _useBreakpoint.xs;
  var _React$useContext = React.useContext(ConfigContext),
    getPrefixCls = _React$useContext.getPrefixCls,
    direction = _React$useContext.direction,
    _React$useContext$pag = _React$useContext.pagination,
    pagination = _React$useContext$pag === void 0 ? {} : _React$useContext$pag;
  var prefixCls = getPrefixCls("pagination", customizePrefixCls);
  var mergedShowSizeChanger = showSizeChanger !== null && showSizeChanger !== void 0 ? showSizeChanger : pagination.showSizeChanger;
  var getIconsProps = function getIconsProps() {
    var ellipsis = /*#__PURE__*/_jsx("span", {
      className: "".concat(prefixCls, "-item-ellipsis"),
      children: "\u2022\u2022\u2022"
    });
    var prevIcon = /*#__PURE__*/_jsx("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(LeftOutlined, {})
    });
    var nextIcon = /*#__PURE__*/_jsx("button", {
      className: "".concat(prefixCls, "-item-link"),
      type: "button",
      tabIndex: -1,
      children: /*#__PURE__*/_jsx(RightOutlined, {})
    });
    var jumpPrevIcon = /*#__PURE__*/_jsx("a", {
      className: "".concat(prefixCls, "-item-link"),
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(prefixCls, "-item-container"),
        children: [/*#__PURE__*/_jsx(DoubleLeftOutlined, {
          className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis]
      })
    });
    var jumpNextIcon = /*#__PURE__*/_jsx("a", {
      className: "".concat(prefixCls, "-item-link"),
      children: /*#__PURE__*/_jsxs("div", {
        className: "".concat(prefixCls, "-item-container"),
        children: [/*#__PURE__*/_jsx(DoubleRightOutlined, {
          className: "".concat(prefixCls, "-item-link-icon")
        }), ellipsis]
      })
    });
    // change arrows direction in right-to-left direction
    if (direction === "rtl") {
      var _ref2 = [nextIcon, prevIcon];
      prevIcon = _ref2[0];
      nextIcon = _ref2[1];
      var _ref3 = [jumpNextIcon, jumpPrevIcon];
      jumpPrevIcon = _ref3[0];
      jumpNextIcon = _ref3[1];
    }
    return {
      prevIcon: prevIcon,
      nextIcon: nextIcon,
      jumpPrevIcon: jumpPrevIcon,
      jumpNextIcon: jumpNextIcon
    };
  };
  var renderPagination = function renderPagination(contextLocale) {
    var _classNames;
    var locale = _objectSpread(_objectSpread({}, contextLocale), customLocale);
    var isSmall = size === "small" || !!(xs && !size && responsive);
    var selectPrefixCls = getPrefixCls("select", customizeSelectPrefixCls);
    var extendedClassName = classNames((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-mini"), isSmall), _defineProperty(_classNames, "".concat(prefixCls, "-rtl"), direction === "rtl"), _classNames), className);
    return /*#__PURE__*/_jsx(RcPagination, _objectSpread(_objectSpread(_objectSpread({}, getIconsProps()), restProps), {}, {
      prefixCls: prefixCls,
      selectPrefixCls: selectPrefixCls,
      className: extendedClassName,
      selectComponentClass: selectComponentClass || (isSmall ? MiniSelect : MiddleSelect),
      locale: locale,
      showSizeChanger: mergedShowSizeChanger
    }));
  };
  return (
    /*#__PURE__*/
    // @ts-ignore
    _jsx(LocaleReceiver, {
      componentName: "Pagination",
      defaultLocale: enUS,
      children: renderPagination
    })
  );
};
export default Pagination;